import { EShopCategory } from '~/src/api/content/shop/getShopItems';

export const EQUIPMENT_ROUTES_MAP = {
    '/internet/equipment': EShopCategory.Routers,
    '/internet/yandex-stanciya': EShopCategory.YandexStation,
    '/domru-tv/equipment': EShopCategory.Decoders,
};
